import {showAlert} from '../actions/miscellaneousActions';
import {get} from '../HTTP';
import { getUserData } from './utilityServices';

export async function getUserGraphData() {
    try {
        const userData = getUserData();
        const category = userData.category || 'all';
        return await get(`/Statsbyusers/${category}`, {});
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                allowEscapeKey: false,
                allowOutsideClick: false,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function getYearGraphData(year: string, category: string = 'all') {
    try {
        return await get(`/Statsbyyear/${year}/${category}`, {});
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                allowEscapeKey: false,
                allowOutsideClick: false,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function getUsersByCategoryAndMonth(category: string, month: string, year?: string) {
    try {
        const userData = getUserData();
        const companyId = userData.Organization || userData.CompanyId;
        
        // ✅ Agar year nahi aaya toh current year use karo
        const selectedYear = year || new Date().getFullYear().toString();
        
        const response = await get(
            `/UsersByCategoryMonth?category=${category}&month=${month}&year=${selectedYear}&companyId=${companyId}`,
            {}
        );
        
        if (response && response.users) {
            return response;
        }
        
        return { users: [] };
    } catch (error) {
        console.error('❌ Error fetching users:', error);
        return { users: [] };
    }
}
//  Category parameter with default value
export async function getCategoryWiseData(year: string, categoryParam?: string) {
    try {
        
        //  Category parameter support
        const category = categoryParam || 'all';
        
        const response = await get(`/Statsbycategory/${year}/${category}`, {});
        
        if (response && response.categories) {
            return response;
        }
        return null;
    } catch (error) {
        console.error('❌ [getCategoryWiseData] Error:', error);
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/dashboardService.tsx